import React, { Component } from 'react'
import TextareaAutosize from 'react-textarea-autosize';
import axios from 'axios';
import {axiosEH} from './common/functions'
const Joi = require('joi');

class ContactForm extends Component {
  // 1. 1st-level vars
  constructor() {
    super()
    this.state = {
      username: '',
      email: '',
      subject: '',
      message: '',
      statusMsg: ''
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.hcCheckbox = this.hcCheckbox.bind(this)
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value   // .trim()
    })
  }

  hcCheckbox() {
    this.setState({ isTeacher: !this.state.isTeacher });
  }

  handleSubmit(event) {
    event.preventDefault();
    const minLen = parseInt(process.env.REACT_APP_USER_INP_MIN_LEN);
    const username = this.state.username;
    const email = this.state.email;
    const subject = this.state.subject;
    const message = this.state.message;
    //console.log(this.state);

    const schema = Joi.object().keys({
      //username: Joi.string().min(minLen).required().regex(/[-]/, { invert: true }),
      username: Joi.string().min(1).required().regex(/[-]/, { invert: true }),
      email: Joi.string().email({ tlds: { allow: false } }).min(minLen).required(),
      subject: Joi.string().min(minLen).required(),
      message: Joi.string().min(minLen),
    });

    const dataToVal = { username, email, subject, message };      
    const ret = schema.validate(dataToVal);
    const { error, value } = ret;
    if (error) {
      var arr = error.details;
      const msg = arr[0];
      this.setState({ statusMsg: String(msg.message) });
      return;
    }

    axios.post(process.env.REACT_APP_BASEURL + '/username/email', {
      username: this.state.username,
      subject: this.state.subject,
      email: this.state.email,
      message: this.state.message,
    })
      .then(res => {	// {info: msg}
        this.setState({ statusMsg: String(res.data.info) });
      })
      .catch(err => { 
        this.setState({ statusMsg: String(axiosEH(err)) });
      })
  }
  // end of f()

  render() {
    return (
      <section className="signup-form is-medium mx-5" style={{ maxWidth: "100%" }} >
        <input className="input is-danger" type="text" name="username"
          placeholder="Your name"
          value={this.state.username.trim()}
          maxLength={process.env.REACT_APP_USER_INP_MAX_LEN}
          onChange={this.handleChange}>
        </input>

        <input className="input is-danger" type="text" name="email"
          placeholder="your.email@example.com"
          value={this.state.email.trim()}
          onChange={this.handleChange}>
        </input>
        
        <input className="input is-danger" type="text" name="subject"
          placeholder="Subject title"
          value={this.state.subject}
          onChange={this.handleChange}>
        </input> 

        {/* <textarea className="input is-danger" name="message" rows={5}
          style={{
            minHeight: 5,
            resize: "none"
          }}
          placeholder="Your message..."
          value={this.state.message}
          required
          onChange={this.handleChange}>
        </textarea> 
        */}

        <TextareaAutosize className="input is-danger" name="message"
        minRows={2}
        maxRows={10}
        style={{ width: '100%', padding: '10px' }} // Add any custom styles
        placeholder="Your message..."
        onChange={this.handleChange}
        />

        <button className="button is-success"
          onClick={this.handleSubmit}
          type="submit" >Send Message
        </button>

        <br></br> <br></br>
        <label className="label has-text-success">{this.state.statusMsg}</label>
      </section>
    )
  }
}

export default ContactForm